import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMyPlans } from '../../store/reducers/myPlansReducer';
import Tabs from '../MyPlans/Tabs';
import PlanCard from '../MyPlans/PlanCard';
import NoPlan from '../MyPlans/NoPlan';
import Footer from '../Footer/Footer';
import Spinner from './../Spinner';
import './MyPlans.css';
import {checkCustomer} from '../../store/reducers/profileReducer';
import { parseMobileParamsNew, isEncrypted } from './../../utils/Common.js';

const MyPlans = () => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState('active'); // 'active' or 'inactive'
  const { response, loading } = useSelector((state) => state.myPlanList);
  const activePlansCount = response?.active_plans?.length || [];
  const inActivePlansCount = response?.inactive_plans?.length || [];
  const activePlans = response?.active_plans || [];
  const inActivePlans = response?.inactive_plans || [];
  const profileResponse = useSelector((state) => state.profileList);
  const userId = profileResponse?.profileData?.data?.user_id;
  const [hasPlans, setHasPlans] = useState(false);

  console.log("MyPlans profileResponse UserId",userId);
  console.log("MyPlans response",response);
  console.log("MyPlans selectedTab",selectedTab);


useEffect(() => {

    let verifiedData;
    const storedMobile = localStorage.getItem('mblnbr');

    if (storedMobile && JSON.parse(storedMobile).length > 0) {
        const parsed = parseMobileParamsNew();
        console.log("parsedparsedparsed1",parsed);
        verifiedData = parsed?.verifiedData || {};
        console.log("verifiedData1", verifiedData);
        if(parsed ===  null){
          verifiedData = isEncrypted(JSON.parse(storedMobile));
        }
        
    } else {
        const parsed = parseMobileParamsNew();
        console.log("parsedparsedparsed2",parsed);
        verifiedData = parsed?.verifiedData || {};
        console.log("verifiedData2", verifiedData);
    }

    console.log("verifiedData myplan", verifiedData);
    dispatch(checkCustomer(verifiedData));
  }, [dispatch]);
  
  useEffect(() => {
    if (userId) {
      dispatch(fetchMyPlans({ user_id: userId }));
    }
  }, [dispatch, userId]);

  
    useEffect(() => {
        if (response?.success === true) {
            setTimeout(() => setHasPlans(true), 100); // Delay to allow WebView to catch up
        }
    }, [response?.success]);


  if (loading) {
    return (
        <Spinner />
      );
 }

 console.log("hasPlans",hasPlans);
 const plansToShow = selectedTab === 'active' ? activePlans : inActivePlans;

 return (
    <div className="myplans" key={hasPlans ? 'plans' : 'noplan'}>
      {hasPlans ? (
        <>
          <Tabs
            activeCount={activePlansCount}
            inactiveCount={inActivePlansCount}
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
          />
          <div className="plans-section">
            {plansToShow.map((plan, index) => (
              <PlanCard key={index} plan={plan} userId={userId} />
            ))}
          </div>
          <Footer />
        </>
      ) : (
        <div>
            <NoPlan />
        </div>
      )}
    </div>
  );
  
};

export default MyPlans;
